<h2 mat-dialog-title>{{ header }}</h2>
<mat-dialog-content>
  <p>{{ content }}</p>
  @if (isDeleting) {
    <div class="d-flex align-items-center mt-3">
      <div class="spinner-border spinner-border-sm me-2" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <span>{{ busyLabel }}</span>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-dialog-close class="btn btn-secondary me-2" [disabled]="isDeleting" (click)="onCancel()">
    {{ cancelLabel }}
  </button>
  <button class="btn btn-danger" (click)="onConfirm()" [disabled]="isDeleting">
    @if (isDeleting) {
      <span class="spinner-border spinner-border-sm me-1" role="status"></span>
    }
    {{ confirmLabel }}
  </button>
</mat-dialog-actions>
